import { baseApi } from "../baseApi";

export const bomApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBomList: builder.query({
      query: (data) => ({
        url: `/api/resource/BOM`,
        params: {
          fields: '["name","creation","docstatus","item","is_active","is_default"]',
          limit_start: data.page,
          limit_page_length: data.pageSize,
          order_by: "`tabBOM`.`modified` desc"
        },
      }),
    }),
    getBomItemList: builder.query({
      query: () => ({
        url: `/api/resource/Item`,
        params: {
          filters: '[["is_stock_item", "=", 1]]',
        },
      }),
    }),
    getWorkstationList: builder.query({
      query: () => ({
        url: `/api/resource/Workstation`
      }),
    }),
    getOperationList: builder.query({
      query: () => ({
        url: `/api/resource/Operation`
      }),
    }),
    getRawMaterialList: builder.query({
      query: (filters) => ({
        url: `/api/resource/Item`,
        params: {
          filters,
          fields: '["stock_uom","item_code","item_name"]',
        },
      }),
    }),
    postCreateBom: builder.mutation({
      query: (body) => ({
        url: `/api/resource/BOM`,
        method: 'POST',
        body,
      }),
    }),
    postBomListSecond: builder.mutation({
      query: (body) => ({
        url: `/api/method/erpnext.manufacturing.doctype.work_order.work_order.query_sales_order`,
        method: 'POST',
        body,
      }),
    }),
    postSubmitBom: builder.mutation({
      query: (body) => ({
        url: `/api/resource/BOM/${body.id}`,
        method: 'PUT',
        body: body.body,
      }),
    }),
    putSpecificBom: builder.mutation({
      query: ({ bomId, payload }) => ({
        
        url: `/api/resource/BOM/${bomId}`,
        method: 'PUT',
        body:payload,
      }),
    }),
    getFrappeDoc: builder.mutation({
      query: (data) => ({
        url: `/api/method/frappe.client.get`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetBomListQuery,
  useGetBomItemListQuery,
  useGetRawMaterialListQuery,
  usePostBomListSecondMutation,
  usePostCreateBomMutation,
  useGetWorkstationListQuery,
  useGetOperationListQuery,
  usePostSubmitBomMutation,
  usePutSpecificBomMutation,
  useGetFrappeDocMutation,
} = bomApi;
